export const PASSWORD_EXPIRED_ERROR =
    'Server.Session.alert_You_must_change_password';

export const INVALID_VERIFICATION_CODE = 'INVALID_VERIFICATION_CODE';

export const INVALID_VERIFICATION_CODE_MAX_ATTEMPTS_REACHED =
    'INVALID_VERIFICATION_CODE_MAX_ATTEMPTS_REACHED';

export const PASSWORD_CHANGE_MISSING_OTP_ERROR =
    'Server.Session.change_password.one_time_password_missed';

export const AUTH_FAILED_ERROR = 'Server.Session.auth_failed';

export const ACCOUNT_BLOCKED_ERROR = 'Server.Session.auth_failed_acc_blocked';
